import { SxProps, Typography, TypographyProps } from '@mui/material'
import DOMPurify from 'dompurify'

interface Props extends TypographyProps {
  children: string
  sx?: SxProps
  role?: string
  'aria-level'?: number
}

DOMPurify.addHook('afterSanitizeAttributes', function (node) {
  if (node instanceof Element && node.hasAttribute('target') && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener')
  }
})

function InnerHtml(props: Props) {
  const sanitizedHtml = DOMPurify.sanitize(props.children, { FORCE_BODY: true, ADD_ATTR: ['target'] })

  return (
    <Typography
      role={props.role}
      aria-level={props['aria-level']}
      sx={{
        '& a': {
          color: 'primary.main',
          fontWeight: 'bold'
        },
        ...props.sx
      }}
      dangerouslySetInnerHTML={{
        __html: sanitizedHtml
      }}
      data-testid='Typography4ED81DE6'
    />
  )
}

export default InnerHtml
